import { render } from "./ComunaDropdown.vue?vue&type=template&id=e687a306&scoped=true"
import script from "./ComunaDropdown.vue?vue&type=script&lang=js"
export * from "./ComunaDropdown.vue?vue&type=script&lang=js"

import "./ComunaDropdown.vue?vue&type=style&index=0&id=e687a306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e687a306"]])

export default __exports__